export enum BlockActionType {
  NONE = 0,
  SUBMIT = 1,
  CANCEL = 2,
  CLOSE = 3,
  OPEN = 4,
  GET = 5,
  REDIRECT = 6,
  BUY_NOW = 7,
  ADD_TO_CART = 8,
  CLEAR = 9,
  CLICK = 10,
  CHANGE_VIEW = 11,
  SCROLL_TO_TOP = 12,
  /**
   * @description
   * Akcja przewijania slajdu w lewo
   */
  SLIDE_LEFT = 13,
  /**
   * @description
   * Akcja przewijania slajdu w prawo
   */
  SLIDE_RIGHT = 14,
  /**
   * @description
   * Akcja przewijania slajdu w prawo
   */
  PREVIOUS_OBJECT = 15,
  /**
   * @description
   * Akcja przewijania slajdu w prawo
   */
  NEXT_OBJECT = 16,
  /**
   * @description
   * Akcja dodawania kolejnej sekcji w widoku
   */
  ADD_SECTION = 17,
  /**
   * @description
   * Akcja usuwania sekcji w widoku
   */
  REMOVE_SECTION = 18,
  /**
   * @description
   * Akcja powrotu do listy albo strony nadrzędnej podglądu
   */
  BACK_TO_LIST = 19,
  /**
   * @description
   * Otwiera lightbox „Zobacz na ścianie" dla pracy (actionRequestForModelId = id pracy).
   * INT-2 (AT-9086) — CTA wizualizacji na ścianie.
   */
  VIEW_ON_WALL = 20,
}
